import { useState } from "react";

import MotoristaForm from "../../../components/motoristas/form";
import { VerticalContainer } from "../../../components/styled";
import { registerMotorista } from "../../../services/motoristas";

export default function AddMotorista(props) {
  const gestante = props.location.state;

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoading(true);
      return await registerMotorista(values);
    } catch (err) {
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <VerticalContainer>
      <div />
      <MotoristaForm
        initialValues={gestante}
        onFinish={onFinish}
        error={error}
        setError={setError}
        loading={loading}
      />
    </VerticalContainer>
  );
}
